import { render, staticRenderFns } from "./sidebar-details.vue?vue&type=template&id=45c0b350&scoped=true"
import script from "./sidebar-details.vue?vue&type=script&lang=js"
export * from "./sidebar-details.vue?vue&type=script&lang=js"
import style0 from "./sidebar-details.vue?vue&type=style&index=0&id=45c0b350&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c0b350",
  null
  
)

export default component.exports